function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import { Workflow, WorkflowUnit } from "./workflow";
var BaseBuilder = /*#__PURE__*/ function() {
    "use strict";
    function BaseBuilder() {
        var _this = this;
        _classCallCheck(this, BaseBuilder);
        this.targetUnits = [];
        this.findIndex = function(target) {
            return _this.targetUnits.findIndex(function(v) {
                return v.id === target.id;
            });
        };
    }
    var _proto = BaseBuilder.prototype;
    _proto.id = function id(targetId) {
        this.targetId = targetId;
        return this;
    };
    _proto.with = function _with(targetUnits) {
        this.targetUnits = targetUnits;
        return this;
    };
    _proto.template = function template(target) {
        if (!this.targetUnitKey) {
            throw new Error("Invalid workflow builder");
        }
        if (target.id) {
            this.targetId = target.id;
        }
        this.targetUnits = _toConsumableArray(target[this.targetUnitKey]);
        return this;
    };
    _proto.before = function before(targetUnit, newUnit) {
        var unitIndex = this.findIndex(targetUnit);
        if (unitIndex === -1) {
            throw new Error('No unit "'.concat(targetUnit.id, '" found'));
        }
        this.targetUnits = [
            newUnit
        ].concat(_toConsumableArray(this.targetUnits.slice(unitIndex)));
        return this;
    };
    _proto.after = function after(targetUnit, newUnit) {
        var unitIndex = this.findIndex(targetUnit);
        if (unitIndex === -1) {
            throw new Error('No unit "'.concat(targetUnit.id, '" found'));
        }
        this.targetUnits = _toConsumableArray(this.targetUnits.slice(0, unitIndex + 1)).concat([
            newUnit
        ], _toConsumableArray(this.targetUnits.slice(unitIndex + 1)));
        return this;
    };
    _proto.replace = function replace(targetUnit, newUnit) {
        var unitIndex = this.findIndex(targetUnit);
        if (unitIndex === -1) {
            throw new Error('No unit "'.concat(newUnit.id, '" found'));
        }
        this.targetUnits = _toConsumableArray(this.targetUnits.slice(0, unitIndex)).concat([
            newUnit
        ], _toConsumableArray(this.targetUnits.slice(unitIndex + 1)));
        return this;
    };
    _proto.prepend = function prepend(newUnit) {
        this.targetUnits = [
            newUnit
        ].concat(_toConsumableArray(this.targetUnits));
        return this;
    };
    _proto.append = function append(newUnit) {
        this.targetUnits = _toConsumableArray(this.targetUnits).concat([
            newUnit
        ]);
        return this;
    };
    _proto.remove = function remove(targetUnit) {
        var unitIndex = this.findIndex(targetUnit);
        if (unitIndex === -1) {
            return this;
        }
        this.targetUnits = _toConsumableArray(this.targetUnits.slice(0, unitIndex)).concat(_toConsumableArray(this.targetUnits.slice(unitIndex + 1)));
        return this;
    };
    _proto.only = function only(targetUnit) {
        var unitIndex = this.findIndex(targetUnit);
        if (unitIndex === -1) {
            return this;
        }
        this.targetUnits = [
            targetUnit
        ];
        return this;
    };
    _proto.build = function build() {
        if (!this.targetConstructor) {
            throw new Error("Workflow builder missing this.targetConstructor method");
        }
        if (!this.targetId) {
            throw new Error("ID not specified in workflow builder");
        }
        return new this.targetConstructor(this.targetId, this.targetUnits);
    };
    return BaseBuilder;
}();
export var WorkflowBuilder = /*#__PURE__*/ function(BaseBuilder) {
    "use strict";
    _inherits(WorkflowBuilder, BaseBuilder);
    var _super = _createSuper(WorkflowBuilder);
    function WorkflowBuilder() {
        _classCallCheck(this, WorkflowBuilder);
        var _this;
        _this = _super.apply(this, arguments);
        _this.targetUnitKey = "units";
        _this.targetConstructor = Workflow;
        return _this;
    }
    return WorkflowBuilder;
}(BaseBuilder);
export var WorkflowUnitBuilder = /*#__PURE__*/ function(BaseBuilder) {
    "use strict";
    _inherits(WorkflowUnitBuilder, BaseBuilder);
    var _super = _createSuper(WorkflowUnitBuilder);
    function WorkflowUnitBuilder() {
        _classCallCheck(this, WorkflowUnitBuilder);
        var _this;
        _this = _super.apply(this, arguments);
        _this.targetUnitKey = "actions";
        _this.targetConstructor = WorkflowUnit;
        return _this;
    }
    return WorkflowUnitBuilder;
}(BaseBuilder);
